import { encrypt } from '../util/crypto';
import { apiGateMeta } from './api_gate';

class MetaService {
  /**
   * Obtém key de acesso para APIs do Meta
   * @returns {Promise} Promise com os dados da key
   */
  async getKey(code) {
    try {
      const response = await apiGateMeta.post('/key', { code });
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message ||
        'Falha ao obter key';

      console.error('Erro ao obter key:', errorMessage, error.response?.data || error);
      throw new Error(errorMessage);
    }
  }

  /**
   * Troca o código de autorização por um access token
   */
  async exchangeCodeForKey(code) {
    try {
      return await this.getKey(code);
    } catch (error) {
      console.error('Erro ao trocar código por key:', error);
      throw new Error(error.message || 'Falha ao obter key');
    }
  };



  /**
   * Obtém páginas do usuário no Meta
   * @returns {Promise} Promise com a lista de páginas
   */
  async getUserPages(key) {
    try {
      const response = await apiGateMeta.post('/user/pages', { key });
      return response.data;
    } catch (error) {
      console.error('Erro ao obter páginas do usuário:', error);
      throw error;
    }
  }

  /**
   * Obtém formulários de geração de leads de uma página específica
   * @param {string} pageId - ID da página
   * @returns {Promise} Promise com os formulários de leadgen
   */
  async getPageLeadgenForms(pageId, key) {
    try {
      // console.log(`Fetching leadgen forms for page ${pageId} with key ${key}`);
      const response = await apiGateMeta.post(`/page/leadgen-forms`, { pageId, key });
      return response.data;
    } catch (error) {
      console.error(`Erro ao obter formulários de leadgen da página ${pageId}:`, error);
      throw error;
    }
  }

  /**
   * Inscreve-se em webhooks de uma página específica
   * @param {string} pageId - ID da página
   * @param {string} key - Chave de acesso
   * @returns {Promise} Promise com o resultado da inscrição
   */
  async subscribePage(pageId, key) {
    try {
      const response = await apiGateMeta.post(`/page/subscribe`, { pageId, key });
      return response.data;
    } catch (error) {
      console.error(`Erro ao inscrever na página ${pageId}:`, error);
      throw error;
    }
  }

  /**
   * Inscreve-se em webhooks de uma página específica
   * @param {string} pageId - ID da página
   * @param {string} key - Chave de acesso
   * @returns {Promise} Promise com o resultado da inscrição
   */
  async unSubscribePage(pageId, key) {
    try {
      const response = await apiGateMeta.post(`/page/unsubscribe`, { pageId, key });
      return response.data;
    } catch (error) {
      console.error(`Erro ao desinscrever na página ${pageId}:`, error);
      throw error;
    }
  }


  /**
   * Verifica a saúde/status de um pixel específico
   * @param {string} pixelId - ID do pixel
   * @returns {Promise} Promise com o status do pixel
   */
  async checkPixelHealth(pixelId, key) {
    try {
      const token = encrypt(key);
      const response = await apiGateMeta.post(`/pixel/health`, { pixelId, key: token });
      // console.log(`Pixel ${pixelId} health status:`, response.data);
      return response.data;
    } catch (error) {
      console.error(`Erro ao verificar saúde do pixel ${pixelId}:`, error);
      throw error;
    }
  }
}

// Exporta uma instância única do serviço
const metaService = new MetaService();
export default metaService;